@if (nativeLookAndFeel) {
  <ion-item>
    @if (floatingLabel) {
      <ion-label position="floating" [ariaLabel]="ariaLabel">{{ label }}</ion-label>
      <ion-input
        [type]="type"
        [autocomplete]="autocomplete"
        [value]="value"
        (ionInput)="onInput($event)"
        (ionFocus)="onFocus($event)"
        (ionBlur)="onBlur()"
        [placeholder]="placeholder"
        [ariaPlaceholder]="ariaPlaceholder"
        [disabled]="disabled"
        #inputElement
      ></ion-input>
    } @else {
      <ion-input
        [type]="type"
        [autocomplete]="autocomplete"
        [value]="value"
        (ionInput)="onInput($event)"
        (ionFocus)="onFocus($event)"
        (ionBlur)="onBlur()"
        [label]="label"
        [ariaLabel]="ariaLabel"
        [placeholder]="placeholder"
        [ariaPlaceholder]="ariaPlaceholder"
        [disabled]="disabled"
        #inputElement
      ></ion-input>
    }
  </ion-item>
} @else if (tailwind) {
  <div>
    @if (label) {
      <div class="tw-flex tw-justify-between tw-items-center">
        <label class="tw-pb-2 tw-font-bold" [ariaLabel]="ariaLabel" [for]="id">{{ label }}</label>
        <div class="tw-text-sm tw-mb-2">
          <ng-content select="[top-right]"></ng-content>
        </div>
      </div>
    }
    <label
      tabindex="-1"
      [ngClass]="[
        'tw-relative tw-flex tw-gap-2 tw-w-full',
        'tw-bg-white tw-font-normal',
        hideBorders ? 'tw-p-0 -tw-ml-[1px] tw-border-none' : 'tw-p-2 tw-border tw-border-solid tw-border-neutral-300',
        'focus:tw-border-orange focus-visible:tw-border-orange',
        'tw-text-sm tw-text-neutral-950',
        'focus:tw-outline-none focus-visible:tw-outline-none',
        'tw-rounded-md',
        hasFieldError ? 'tw-border-red-500' : ''
      ]"
    >
      @if (type === 'search') {
        <lh-shared-ui-svg-icon [key]="'search'" searchIcon />
      }
      <ng-content select="[searchIcon]"></ng-content>
      <!-- aria-label lands on the CONTROL, not on the wrapper label. Without it a label-less field's
           only accessible name is its placeholder — which some AT/browser pairs never expose as a
           name at all, and which stops describing the field the moment someone types into it.
           Absent when no ariaLabel is passed, so nothing changes for existing callers (AM-4734). -->
      <input
        [id]="id"
        [type]="type"
        [autocomplete]="autocomplete"
        [value]="value"
        (input)="onInput($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur()"
        [placeholder]="placeholder"
        [ariaPlaceholder]="ariaPlaceholder"
        [attr.aria-label]="ariaLabel || null"
        [attr.aria-invalid]="ariaInvalid === null ? null : ariaInvalid"
        [attr.aria-describedby]="ariaDescribedBy || null"
        [required]="required"
        [disabled]="disabled"
        [tabindex]="tabindex"
        class="tw-flex-1 tw-min-w-0 tw-border-none tw-bg-transparent tw-outline-none focus:tw-outline-none focus-visible:tw-outline-none tw-ring-0 focus:tw-ring-0 tw-shadow-none tw-appearance-none placeholder:tw-text-neutral-400"
        [ngClass]="{
          'tw-text-left': textAlign === 'left',
          'tw-text-center': textAlign === 'center',
          'tw-text-right': textAlign === 'right'
        }"
        #inputElement
      />
      <div class="tw-absolute tw-left-0 tw-bottom-0 tw-top-0 tw-flex tw-items-center tw-justify-center tw-flex-col">
        <ng-content select="[left]"></ng-content>
      </div>
      <div class="tw-absolute tw-right-0 tw-bottom-0 tw-top-0 tw-flex tw-items-center tw-justify-center tw-flex-col">
        <ng-content select="[right]"></ng-content>
      </div>
    </label>
  </div>
} @else {
  @if (label) {
    <label [for]="id">{{ label }}</label>
  }
  <input
    [id]="id"
    [type]="type"
    [autocomplete]="autocomplete"
    [value]="value"
    (input)="onInput($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur()"
    [placeholder]="placeholder"
    [ariaPlaceholder]="ariaPlaceholder"
    [required]="required"
    [disabled]="disabled"
    class="form-control"
    #inputElement
  />
}
